import { ValgStateActionTypes, TOGGLE_VILKAR, ToggleVilkarAction, ValgState, UPDATE_VALG } from './Types';

import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import { VeilederOblAppState } from '..';
import { AnyAction } from 'redux';
import { getA, getB, getBx } from '../../Veileder';
import { setVisning } from '../Resultat/Actions';
import AUtdanningValg from '../../Utilities/A-UtdanningsValg';

export function updateValg(newValg: Partial<ValgState>): ValgStateActionTypes {
    return {
        type: UPDATE_VALG,
        payload: newValg,
    };
}

export function toggleVilkar(): ToggleVilkarAction {
    return {
        type: TOGGLE_VILKAR,
    };
}

export const updateVisning = (): ThunkAction<void, VeilederOblAppState, {}, AnyAction> => {
    return (dispatch: ThunkDispatch<VeilederOblAppState, {}, AnyAction>, getState: () => VeilederOblAppState): void => {
        const currentState = getState();
        const visBoksB = visB(currentState);
        const visBoksBx = visBx(currentState);
        const visResultat = visR(currentState, visBoksB, visBoksBx);

        dispatch(setVisning({ visBoksB, visBoksBx, visResultat }));
    };
};

const visB = (state: VeilederOblAppState): boolean => {
    return getA(state.valg) === AUtdanningValg.a1_uniHoysk;
};

const visBx = (state: VeilederOblAppState): boolean => {
    return getA(state.valg) === AUtdanningValg.a4_uniHoyUtl;
};

const visR = (state: VeilederOblAppState, visBoksB: boolean, visBoksBx: boolean): boolean => {
    return (
        getA(state.valg) === AUtdanningValg.a2_folkehogskole ||
        getA(state.valg) === AUtdanningValg.a3_annenHoyere ||
        getA(state.valg) === AUtdanningValg.a5_annenHoyereUtl ||
        (visBoksB && getB(state.valg) !== undefined) ||
        (visBoksBx && getBx(state.valg) !== undefined)
    );
};
